namespace GeniuzPOS.Purchase {
    export namespace PoCNRTVDtService {
        export const baseUrl = 'Purchase/PoCNRTVDt';

        export declare function Create(request: Serenity.SaveRequest<PoCNRTVDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoCNRTVDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoCNRTVDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoCNRTVDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoCNRTVDt/Create",
            Update = "Purchase/PoCNRTVDt/Update",
            Delete = "Purchase/PoCNRTVDt/Delete",
            Retrieve = "Purchase/PoCNRTVDt/Retrieve",
            List = "Purchase/PoCNRTVDt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PoCNRTVDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
